<template>
  <div>
    <div style="width: 500px">
      <div class="crowd-pack-search inlineBlock">
        <el-input v-model="configData.search" placeholder="请输入人群包名称或ID" />
      </div>
      <div class="fr">
        <el-button @click="crowdPackAll('include')">全选定向</el-button>
        <el-button @click="crowdPackAll('exclude')">全选排除</el-button>
      </div>
    </div>
    <div class="crowd-pack-table">
      <el-table
        v-loading="is_loading"
        :data="filterTableData()"
        height="300"
        style="width: 100%"
      >
        <el-table-column
          prop="name"
          label="人群包"
          width="100"
          sortable
        />
        <el-table-column
          prop="tag"
          label="属性"
          width="100"
          :filters="configData.tag_filter_list"
          :filter-multiple="false"
          :filter-method="filterTag"
          :filtered-value="configData.filtered_value"
        />
        <el-table-column
          prop="create_time"
          label="创建时间"
          sortable
        />
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              :disabled="isSelected(scope.row, 'include')"
              @click="crowdPackCheck(scope.row, 'include')"
            >定向</el-button>
            <el-button
              type="text"
              size="small"
              :disabled="isSelected(scope.row, 'exclude')"
              @click="crowdPackCheck(scope.row, 'exclude')"
            >排除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-card class="crowd-pack-card">
      <div slot="header" class="clearfix">
        <span>已选</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="configData.value={
            include:[],
            exclude:[],
          }"
        >清空</el-button>
      </div>
      <div class="card-options">
        <el-tabs v-model="configData.active_name">

          <el-tab-pane name="include">
            <span slot="label">
              <span>定向({{ configData.value['include'].length }})</span>
            </span>
          </el-tab-pane>

          <el-tab-pane name="exclude">
            <span slot="label">
              排除({{ configData.value['exclude'].length }})
            </span>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div style="overflow: auto; height: 185px">
        <div>
          <el-empty v-if="configData.value[configData.active_name].length === 0" :image-size="50" />
          <div v-for="(item, index) in configData.value[configData.active_name]" :key="index" class="crowd-pack-item">
            <span>{{ item.name }}</span>
            <i class="el-icon-close" @click="remove(index, configData.active_name)" />
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import DmpResource from '@/api/dmp/jrtt';
const dmpResource = new DmpResource();

export default {
  props: {
    /**
     * 广告主ID
     */
    advertiserId: {
      type: [Number, String],
      required: true,
    },
    /**
     * 配置数据
     */
    configData: {
      type: Object,
      required: true,
    },
  },
  data: function() {
    return {
      is_loading: false,
    };
  },
  created() {
    this.getDmpList({
      advertiser_id: this.advertiserId,
      status: 2,
    }).then((res) => {
      this.configData.options = res.list;

      // 匹配到的人群包数据
      const temp = {
        include: [],
        exclude: [],
      };

      // 过滤出tag属性列表
      this.configData.options.forEach(item => {
        const is_exist = this.configData.tag_filter_list.some(option_item => {
          return option_item.value === item.tag;
        });

        if (!is_exist) {
          this.configData.tag_filter_list.push({
            text: item.tag,
            value: item.tag,
          });
        }

        // 根据人群包ID匹配数据
        this.configData.value.include.forEach(include_item => {
          if (item.custom_audience_id === include_item) {
            temp.include.push(item);
          }
        });

        // 根据人群包ID匹配数据
        this.configData.value.exclude.forEach(exclude_item => {
          if (item.custom_audience_id === exclude_item) {
            temp.exclude.push(item);
          }
        });
      });

      // 向下兼容，数据若为人群包数据，则无需格式化（如：头条体验版 - 智能创建 - 旧模板数据）
      if (
        (this.configData.value.include.length && typeof this.configData.value.include[0] === 'number') ||
        (this.configData.value.exclude.length && typeof this.configData.value.exclude[0] === 'number')
      ) {
        this.configData.value = temp;
      }
    });
  },
  methods: {
    /**
     * 人群包选中
     * @param {*} val 值
     * @param {*} key 键值
     */
    crowdPackCheck(val, key) {
      if (!this.isSelected(val, key)) {
        this.configData.value[key].push(val);
      } else {
        return;
      }

      let temp_key = '';
      if (key === 'include') {
        temp_key = 'exclude';
      } else if (key === 'exclude'){
        temp_key = 'include';
      }
      const index = this.configData.value[temp_key].findIndex((item) => {
        return item.type_id === val.type_id;
      });
      if (index !== -1) {
        this.configData.value[temp_key].splice(index, 1);
      }

      this.configData.active_name = key;
    },
    // 过滤属性
    filterTag(value, row) {
      return row.tag === value;
    },
    // 移除
    remove(index, key) {
      this.configData.value[key].splice(index, 1);
    },
    // 判断是否选中
    isSelected(row, key) {
      const index = this.configData.value[key].findIndex((item) => {
        return item.type_id === row.type_id;
      });
      if (index === -1) {
        return false;
      } else {
        return true;
      }
    },
    // 过滤表格数据
    filterTableData() {
      const data = this.configData.options.filter(data => !this.configData.search || data.name.toLowerCase().includes(this.configData.search.toLowerCase()) || data.type_id.toLowerCase().includes(this.configData.search.toLowerCase()));
      return data;
    },
    // 人群包选中所有
    crowdPackAll(key) {
      let temp_crowd_pack = this.filterTableData();

      // 是否使用到属性过滤
      if (this.configData.filtered_value[0]) {
        temp_crowd_pack = temp_crowd_pack.filter(item => {
          return item.tag === this.configData.filtered_value[0];
        });
      }

      // 判断当前过滤完人群包数量，数组长度大于0，则根据key进行定向或排除到对应的数组
      if (temp_crowd_pack.length > 0) {
        temp_crowd_pack.forEach(item => {
          this.crowdPackCheck(item, key);
        });
      } else {
        this.$message.warning('人群包数据为空，无法进行定向或排除！');
      }
    },
    // 获取人群包列表数据
    getDmpList: function(params) {
      this.is_loading = true;
      return new Promise((resolve, reject) => {
        dmpResource
          .getApi(params)
          .then((response) => {
            resolve(response);
            this.is_loading = false;
          })
          .catch((error) => {
            reject(error);
            this.is_loading = false;
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.crowd-pack-search {
    width: 300px;
    padding-bottom: 10px;
}
.crowd-pack-table {
    width: 300px;
    display: inline-block;
    border: 1px solid #e6ebf5;
}
.crowd-pack-card {
    display: inline-block;
    width: 200px;
    height: 300px;
    /deep/ .el-card__header {
        padding: 9px 20px;
    }
    /deep/ .el-card__body {
        padding: 0 10px;
    }
    .card-options {
        .el-link {
            margin-right: 10px;
        }
    }
}
.crowd-pack-item {
    width: 100%;
    background: #f0f0f0;
    margin-bottom: 5px;
    >span {
    display: inline-block;
    width: 90%;
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
    }
    >i {
    cursor: pointer;
    }
}
</style>
